// version v1857

import customRouter from './cctv_router'

export default customRouter.router
